import { z } from "zod";
import moment from "moment";
import { unformat } from "v-money3";
import { isDateFuture } from "@/utils/FormValidators";
import { MINIMUM_APPOINTMENT_PRICE } from "@/constants";

const MAXIMUM_APPOINTMENT_PRICE = 9999;
const moneyConfig = {
  prefix: "R$ ",
  thousands: "",
  decimal: ",",
  precision: 2,
};
export const shareScheduleValueRangeMsg = `Informe um valor entre R$${MINIMUM_APPOINTMENT_PRICE},00 e R$${MAXIMUM_APPOINTMENT_PRICE},00`;

const isValueInRange = (v: string | number) => {
  if (!v) return true;
  const n = unformat(String(v), moneyConfig) as number;
  return n >= MINIMUM_APPOINTMENT_PRICE && n <= MAXIMUM_APPOINTMENT_PRICE;
};

export const shareScheduleSchema = z
  .object({
    date: z
      .string()
      .min(1, "Informe a data da sessão")
      .refine(isDateFuture, "Informe uma data válida"),
    time: z.string().min(1, "Informe o horário da sessão"),
    value: z.any().optional().refine(isValueInRange, shareScheduleValueRangeMsg),
  })
  .superRefine((data, ctx) => {
    if (
      data.time &&
      !moment(`${data.date} ${data.time}`).isSameOrAfter(moment(), "m")
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["time"],
        message: "Informe um horário válido",
      });
    }
  });
export type ShareScheduleValues = z.infer<typeof shareScheduleSchema>;
